import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

export function plainTextLength(value: string | Nullish) {
  if (isNil(value)) {
    return 0;
  }

  if (!value.trim().startsWith('<')) {
    return value.length;
  }

  // Images contribute no visible text but their (often huge, base64) markup makes DOMParser slow.
  // Stripping them keeps the count identical while making it fast even with embedded images.
  const withoutImages = value.replace(/<img\b[^>]*>/gi, '');

  const parser = new DOMParser();
  const documentNode = parser.parseFromString(withoutImages, 'text/html');

  return (documentNode.body.textContent ?? '').replace(/\u00a0/g, ' ').length;
}
